import React, { useState, useEffect } from "react";
import { Autocomplete } from "@hopper/autocomplete";

import { Option } from "helpers/form_helper";

export type ControlledAutocompleteProps = {
  name: string;
  options?: Option[] | undefined;
  size?: "sm" | "md";
  placeholder?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSelect: (option: { label: string; value: string }) => void;
  onOutsideClick?: () => void;
  value?: string;
  isLoading?: boolean;
};

const ControlledAutocomplete = ({
  name,
  options = [],
  size = "sm",
  placeholder = "Start typing to see suggestions...",
  onChange,
  onSelect,
  onOutsideClick = () => {},
  value = "",
  isLoading = false,
  ...otherInputProps
}: ControlledAutocompleteProps) => {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => setInputValue(value), [value]);

  const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.persist();
    const value = event.target.value;

    setInputValue(value);
    onChange(event);
  };

  const onAutocompleteSelect = ({ label, value }: Option) => {
    setInputValue(label);
    onSelect({ label, value });
  };

  return (
    <Autocomplete
      onSelect={onAutocompleteSelect}
      options={options}
      onOutsideClick={onOutsideClick}
      value={inputValue}
      isLoading={isLoading}
      inputProps={{
        type: "text",
        autoComplete: "off",
        onChange: onInputChange,
        placeholder,
        name,
        size,
        ...otherInputProps,
      }}
    />
  );
};

export default ControlledAutocomplete;
